import React from 'react'
import { Link } from 'react-router-dom'

// Placeholder for restaurant sub-modules that haven't been ported into web yet.
function ComingSoon({ title }) {
  return (
    <div className='tw-max-w-2xl tw-mx-auto tw-text-center tw-py-16'>
      <h3 className='font-heading tw-text-2xl tw-mb-2'>{title || 'Coming soon'}</h3>
      <p className='tw-text-gray-500 tw-text-sm tw-mb-6'>
        This module is being moved into the LoyalIdeas dashboard and will be
        available here shortly.
      </p>
      <Link
        to='/order-management'
        className='tw-inline-block tw-rounded-[6px] tw-bg-electricGreen tw-text-white tw-text-regular tw-py-[8px] tw-px-[24px]'
      >
        Back to Order management
      </Link>
    </div>
  )
}

export default ComingSoon
